import React, { useContext } from "react";
import Link from "next/link";
import Image from "next/image";
import { BASE_ASSETS_URL } from "../../constants/constants";
import AppContext from "../AppContext";
import { FeatureCards } from "@components/Cards/FeatureCards";
import { ButtonPrimary } from "@components/Buttons";
import { createUTMQueryParams } from "@utils/signature_owner";
import { CLMButtonPrimary, CLMButtonPrimary1 } from "components/CLM/v3/Buttons";
import { HiArrowLongRight } from "react-icons/hi2";

const StickyLoginCard = ({
  pageProduct = "",
  cardWidth = "xs:w-[360px]",
  title,
  description,
}) => {
  const context = useContext(AppContext);

  const content = {
    default: {
      title: "Create a free BoloForms account today!",
      description:
        "Create your free account today and start creating your own digital signature.",
      link: `https://sheetgod.boloforms.com/login?from=${
        context.globalData.from || "STICKY_CARD"
      }`,
    },
    approvals: {
      title: "Create a free BoloForms account today!",
      description:
        "Create your free account today and start creating your approval workflows.",
      link: `https://approval-dashboard.boloforms.com/login?from=${
        context.globalData.from || "STICKY_CARD"
      }`,
    },
    signature: {
      title: "Tired of nonsense pricing of DocuSign?",
      description:
        "Start taking digital signatures with BoloSign and save money.",
      link: `https://signature.boloforms.com/register?from=${
        context.globalData.from || "STICKY_CARD"
      }`,
    },
    "timer-proctor": {
      title: "Create a free BoloForms account today!",
      description:
        "Create your free account today and start creating tests using BoloForms Timer + Proctor.",
      link: `https://dashboard.boloforms.com/login?from=${
        context.globalData.from || "STICKY_CARD"
      }`,
    },
    sheetgod: {
      title: "Create a free BoloForms account today!",
      description:
        "Create your free account today and start enhancing your sheets using BoloForms SheetGod.",
      link: `https://sheetgod.boloforms.com/login?from=${
        context.globalData.from || "STICKY_CARD"
      }`,
    },
    taxes: {
      title: "Create a free BoloForms account today!",
      description:
        "Create your free account today and start creating your own digital signature.",
      link: `https://signature.boloforms.com/login?from=${
        context.globalData.from || "STICKY_CARD"
      }${createUTMQueryParams({
        utmData_: context.globalData.utmData,
        from: "STICKY_CARD",
      })}`,
    },
  };

  const contentToDisplay =
    pageProduct && content[pageProduct]
      ? content[pageProduct]
      : content.signature;

  return (
    //   <div className="max-w-screen-mxl mx-auto">
    //   {
    //     <FeatureCards
    //       cardsData={featuresData}
    //       featuresStyling={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-10`}
    //     />
    //   }
    //   <div className="mt-10 flex justify-center items-center">
    //     <ButtonPrimary buttonText={`All Features`} buttonUrl={`#`} />
    //   </div>
    // </div>

    <div
      className={`w-full ${cardWidth} mx-auto border border-surface-dark  px-6 pt-7 pb-9 flex flex-col gap-4 text-center justify-center items-center rounded-xl bg-surface`}
    >
      <Image
        src={`${BASE_ASSETS_URL}/boloforms-signature/boloforms-logo.png`}
        className="w-auto h-auto rounded-full"
        width={10}
        height={10}
        alt="BoloForms"
      />
      <div className="w-full flex flex-col gap-4">
        <h3 className="text-2xl">{title ? title : contentToDisplay.title}</h3>
        <p className="text-gray-600">
          {description ? description : contentToDisplay.description}
        </p>
        {/* <Link
          href={contentToDisplay.link}
          className="w-full text-white bg-violet-600 py-3 px-8 rounded-full cursor-pointer font-semibold hover:opacity-90"
        >
          Create Free Account
        </Link> */}
        <div className=" flex justify-center items-center">
          <CLMButtonPrimary
            buttonText={`Get started for free`}
            buttonUrl={contentToDisplay.link}
            icon={<HiArrowLongRight />}
          />
        </div>
      </div>
    </div>
  );
};

export default StickyLoginCard;
